import { isEmpty } from 'lodash-es'

/**
 * Kontak di header struk: data outlet diprioritaskan, fallback data perusahaan.
 */
export const getReceiptContact = (outlet, companyOptions) => ({
  address: !isEmpty(outlet?.address) ? outlet.address : companyOptions?.property_address,
  phone: !isEmpty(outlet?.phone) ? outlet.phone : companyOptions?.property_phone,
})
